var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["header/utility-account-image.j2"] = require( "header/utility-account-image.j2" );
dependencies["header/utility-dropdown-asset.j2"] = require( "header/utility-dropdown-asset.j2" );
dependencies["header/utility-account-links.j2"] = require( "header/utility-account-links.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/utility-account.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/header/utility-account.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("accountUrl")) {
var t_4 = t_1.accountUrl;
} else {
cb(new Error("cannot import 'accountUrl'")); return;
}
context.setVariable("accountUrl", t_4);
output += "\n\n<li class=\"c-utility__li c-utility__account dom-utility-account ";
if(runtime.contextOrFrameLookup(context, frame, "shouldHideHeaderLogin")) {
output += "u-off-screen-hidden";
;
}
output += "\">\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loggedIn")) {
output += "\n        <div class=\"js-dropdown-toggle-hover\">\n            <div class=\"c-utility-toggle-outer js-dropdown-container\" role=\"menubar\" data-qa-account-menu>\n\n                <a class=\"u-extra-small--hide u-large--show c-utility__a c-utility-toggle__title\" role=\"menuitem\" data-qa-logged-in href=\"";
output += runtime.suppressValue((lineno = 7, colno = 149, runtime.callWrap(t_4, "accountUrl", context, ["dashboard",runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\">\n\n                    ";
env.getTemplate("header/utility-account-image.j2", false, "core/templates/header/utility-account.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n                    ";
output += runtime.suppressValue((lineno = 11, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["utility-my-account"])), env.opts.autoescape);
output += "\n\n                </a>\n\n                <span class=\"c-utility__a c-utility-toggle__title c-utility-toggle__title--hide js-dropdown-toggle\" role=\"menuitem\" data-qa-logged-in>\n\n                    ";
env.getTemplate("header/utility-account-image.j2", false, "core/templates/header/utility-account.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n                    ";
output += runtime.suppressValue((lineno = 19, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["utility-my-account"])), env.opts.autoescape);
output += "\n\n                </span>\n\n                ";
env.getTemplate("header/utility-dropdown-asset.j2", false, "core/templates/header/utility-account.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n\n                <div class=\"c-utility-toggle-inner\" role=\"menu\" data-qa-account-utility-toggle-inner>\n\n                    <ul class=\"c-utility-toggle__ul\">\n\n                        ";
env.getTemplate("header/utility-account-links.j2", false, "core/templates/header/utility-account.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n\n                    </ul>\n\n                </div>\n\n            </div>\n        </div>\n\n    ";
})})})})})})})});
}
else {
output += "\n\n        <a ";
output += runtime.suppressValue((lineno = 40, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["top_nav","Login"])), env.opts.autoescape);
output += " data-cm-element=\"account_login_modal\" class=\"js-signin c-utility__a c-utility__a--sign-in c-utility-toggle__title\" href=\"\" rel=\"nofollow\" data-qa-header-login>\n\n            ";
env.getTemplate("header/utility-account-image.j2", false, "core/templates/header/utility-account.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n\n            ";
output += runtime.suppressValue((lineno = 44, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["utility-my-account-sign-in-up"])), env.opts.autoescape);
output += "\n        </a>\n\n    ";
})});
}
output += "\n</li>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/utility-account.j2"] , dependencies)